// extracted by mini-css-extract-plugin
module.exports = {"page":"Cd","modal":"Dd","actions":"Ed","step":"Fd","logos":"Gd","primary":"Hd","disabled":"Id","cancel":"Jd","bodyOpen":"Kd","primeLogo":"Ld","vipLogo":"Md","plus":"Nd"};